import { render, staticRenderFns } from "./AiOffice.vue?vue&type=template&id=70460108"
import script from "./AiOffice.vue?vue&type=script&lang=js"
export * from "./AiOffice.vue?vue&type=script&lang=js"
import style0 from "./AiOffice.vue?vue&type=style&index=0&id=70460108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports